module.exports = __webpack_public_path__ + "img/HOME.a44238d1.svg";